import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-order-success',
  imports: [DatePipe],
  templateUrl: './order-success.component.html',
  styleUrl: './order-success.component.scss'
  // providers: [DatePipe]
})
export class OrderSuccessComponent implements OnInit {

  orderDate: any = Date.now();
  state: any;

  ngOnInit(): void {
    this.state = history.state;

  }

}
